import React, { useEffect } from "react";
import cookie from "react-cookies";
import SearchForm from "components/SearchForm";
import MenuDesktop from "components/MenuDesktop";
import ProfileMenu from "components/ProfileMenu";
import Footer from "layout/Footer";
import { login, isSignedIn, checkLogin } from "utils/wallet";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const handleLogin = async () => {
    await login();
  };

  useEffect(() => {
    !cookie.load("user") && checkLogin();
  }, []);

  const handleLogoClick = () => {
    if (cookie.load("user") === undefined) {
      toast.warning("Please login to search!");
      return;
    } else if (cookie.load("user").organization !== "Gyde") {
      toast.warning("You are not in Gyde Organization.");
      return;
    } else {
      navigate("/search/all");
    }
  };

  return (
    <>
      <header className="relative h-[480px] flex flex-col lg:h-[344px] md:h-[344px] sm:h-[375px]">
        {cookie.load("user") && (
          <div className="absolute top-[16px] right-0 z-50">
            <ProfileMenu />
          </div>
        )}
        <img
          src="/background.jpg"
          alt="background"
          className="absolute w-full bottom-0 z-0 h-full object-cover max-w-full"
        />
        <div className="absolute w-full h-full bg-theme z-0 opacity-[78%] z-1"></div>
        <img
          src="/logo-v.png"
          alt="logo"
          className="relative z-2 w-36 h-32 mt-[40px] ml-[40px] lg:w-[88px] lg:h-20 hidden xl:block"
          onClick={handleLogoClick}
        />
        <div className="containers relative z-1 flex flex-col items-center mt-20 lg:mt-10 md:mt-[32px] sm:mt-[32px]">
          <img
            src="/logo-v.png"
            alt="logo"
            className="relative z-2 xl:hidden w-[88px] h-20 mb-[36px]"
            onClick={handleLogoClick}
          />
          <div className="w-full xl:w-[1014px] lg:w-[714px]">
            <SearchForm />
            {!cookie.load("user") ? (
              <div className="flex gap-[20px] mt-[32px]">
                <button className="high-emphasis" onClick={handleLogin}>
                  LOGIN
                </button>
                <button
                  className="high-emphasis"
                  onClick={() =>
                    window.open(
                      "https://elqiyqo3xy2.typeform.com/to/iHcd1Bqd",
                      "_blank"
                    )
                  }
                >
                  SIGN UP
                </button>
              </div>
            ) : (
              <div className="mt-8">
                <MenuDesktop />
              </div>
              // )
            )}
          </div>
        </div>
      </header>
      <main className="grid xl:my-16 xl:w-[1200px] xl:mx-auto lg:my-[24px] lg:mx-16 md:my-[24px] md:mx-16 xl:gap-16 lg:gap-12 md:gap-12 sm:my-[32px] sm:mx-[24px] sm:gap-10">
        <h1>Find Local Help, fast</h1>
        <div className="flex gap-[72px] md:gap-[24px] sm:flex-col sm:gap-[16px]">
          <p className="md:text-base grow">
            Using our unique NFT-gated platform, finding help has never been
            easier. Starting in Baltimore City, we're mapping out the entire
            helping ecosystem for those who need it. Only those who need help
            can see the reviews relevant to them. Are you in Baltimore City and
            need help? Click 'Sign Up' above and we'll review your application
            asap!
          </p>
          <img
            src="/background.jpg"
            alt="background"
            className="xl:w-[500px] xl:h-[333px] md:w-[40%] md:object-contain mb-auto max-w-full"
          />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Home;
